import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getTextContrast } from "../../../../../utils";
import get from "lodash/get";
import "./button.module.css";

export const Button = ({ text, clickHandler, disable, enableEnterClick = false }) => {
  const enableDarkMode = useSelector((state) => get(state, ["header", "isDarkModeEnabled"], false));
  const { login = {}, general = {} } = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config"], {}));
  const { buttonColor, darkButtonColor } = get(login, ["pageSetting"], {});
  const { darkPrimaryColor = "#3cab92", primaryColor = "#3cab92" } = general;
  const buttonBgColor = enableDarkMode ? darkButtonColor || darkPrimaryColor : buttonColor || primaryColor;
  const textColor = getTextContrast(buttonBgColor) === "dark" ? "#000" : "#fff";

  useEffect(() => {
    if (!enableEnterClick) {
      return;
    }
    if (!disable) {
      const handleKeyPress = (event) => event?.key === "Enter" && clickHandler();
      window?.document?.addEventListener("keydown", handleKeyPress);
      return () => {
        window?.document?.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [enableEnterClick, disable, text, clickHandler]);

  return (
    <button
      className="auth--background-color auth--button"
      disabled={disable}
      onClick={() => clickHandler()}
      styleName={disable ? "custom-button opacity" : "custom-button"}
      style={{ color: textColor }}
    >
      {text}
    </button>
  );
};
